export default __webpack_public_path__ + "static/media/hang.a09ef7b4.svg";